import { NavigationService } from "@/shared/services/NavigationService";
import { SystemView } from "@/shared/constants/Views.enum";
import { Component, Vue, Inject, Watch } from "vue-property-decorator";
import { STYLE_CLASSES } from "../../shared/constants/StyleConstants";
import {
  USER_ACCESS,
  USER_CONSTANTS,
  USER_MESSAGES,
  USER_STATES
} from "./constants/UserConstants";
import { UserService } from "./services/UserService";
import { UserPagination } from "./models/UserPagination";
import { Response } from "@/shared/models/Response";
import { UserQuery } from "./models/UserQuery";
import { Http } from "@status/codes";
import { UserStatus } from "./models/UserStatus";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import ListItem from "@/shared/components/ListItem/ListItem.vue";
import ScrollBottom from "@/shared/components/ScrollBottom/ScrollBottom.vue";
import EmptyState from "@/shared/components/EmptyState/EmptyState.vue";
import SaveUserTemplate from "../UserTemplate/components/SaveUserTemplate/SaveUserTemplate.vue";
import SaveRole from "../Roles/components/SaveRole/SaveRole.vue";
import ModalTemplate from "@/shared/components/ModalTemplate/ModalTemplate.vue";
import { MenuDataStructure } from "@/shared/models/MenuDataStructure";
import ObservationModal from "@/shared/components/ObservationModal/ObservationModal.vue";
import FormModalViewer from "@/shared/components/FormModalViewer/FormModalViewer.vue";
import { UserModel } from "./models/UserModel";
import { SearchContext } from "@/shared/models/SearchContext";
import { Route, NavigationGuardNext } from "vue-router";
import SaveUser from "./components/SaveUser/SaveUser.vue";
import { mapGetters } from "vuex";
import { List } from "@/shared/components/GenericSearchBar/model/List";
import store from "@/store";
import {
  COLLECTIONS_NAME,
  COMPONENT_NAME_MODAL,
  FORM_MESSAGES,
  LIST_DATA_EVENTS,
  LOCAL_STORAGE
} from "@/shared/constants/FormConstants";
import {
  GENERAL_CONSTANTS,
  KEYTYPE_CONSTANTS,
  PANEL_INFO_CONSTANTS,
  STATE,
  STORE_CONSTANTS
} from "@/shared/constants/GeneralConstants";
import { Utils } from "@/shared/utils/utils";
import { SearchContextModal } from "@/shared/models/SearchContextModal";
import SaveDependencies from "../Dependencies/components/SaveDependencies/SaveDependencies.vue";
import { FORM_TEMP_CONSTANTS } from "../FormTemplate/constants/FormTemplateConstants";
import { RolesService } from "../Roles/services/RolesService";
import { LACK_OF_OPTIONS } from "../Dashboards/AdminDashboard/constants/AdminDashboardConstants";
import { DependenciesService } from "../Dependencies/services/DependenciesService";
import { ListService } from "../List/services/ListService";
import lodash from "lodash";
import { SecondaryFilter } from "../Dashboards/AdminDashboard/models/SecondaryFilter";
import { LIST_CONSTANTS } from "../List/constants/ListConstants";

Component.registerHooks(["beforeRouteLeave"]);
@Component({
  name: "User",
  components: {
    EmptyState,
    FormModalViewer,
    ScrollBottom,
    ListItem,
    ModalTemplate,
    ObservationModal,
    SaveUserTemplate,
    SaveRole,
    SaveUser,
    SaveDependencies
  },
  computed: {
    ...mapGetters({
      dataToMainView: "getDataToMainView",
      dataToLateralMenu: "getDataToLateralMenu"
    })
  }
})
export default class User extends Vue {
  @Inject() userService!: UserService;
  @Inject() rolesService!: RolesService;
  @Inject() dependenciesService!: DependenciesService;
  @Inject() listService!: ListService;

  dataToMainView!: MenuDataStructure;
  dataToLateralMenu!: MenuDataStructure;

  loadingData = false;
  filterArray = USER_CONSTANTS.USER_FILTERS.MAIN;
  userData: UserStatus[] = [];
  userList!: Response<UserPagination>;
  userModel: UserModel = {
    extraInfoGroups: [],
    fields: {},
    roles: [""],
    state: "",
    user: "",
    userTemplate: "",
    schema: {
      phoneComponentList: [],
      schema: {
        allOf: [],
        type: "",
        "x-display": ""
      }
    }
  };
  dateCreated = "";
  dateModified = "";
  dialogPreview = false;
  clearModel = false;
  idReference = "";
  canSearch = true;
  cardClass = STYLE_CLASSES.CARD;
  admin = false;
  showModalUserTemplate = false;
  showModalRole = false;
  showModalDependencies = false;
  itemList: Array<UserStatus> = [];
  querySearch: UserQuery = {};
  docRef = "";
  isVisibleSaveUser = false;
  userId = "";
  currentIcon = GENERAL_CONSTANTS.ICONS.ADD;
  tooltip = USER_CONSTANTS.BUTTON.ADD_USER_TEXT;
  userSelected?: UserStatus = {
    id: "",
    userName: "",
    userState: "",
    userEmail: "",
    userPhone: "",
    userDocument: "",
    userAvatar: "",
    name: ""
  };

  outdatedMessage = "";
  key = 0;
  userDocument = "";
  userNameSearch = "";

  primaryBtnRoundClass = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  EMPTY_STATE_HEADER = USER_MESSAGES.INFO.NO_INFO_TO_SHOW;
  EMPTY_STATE_PARAGRAPH = USER_MESSAGES.INFO.EMPTY_STATE_TEXT;
  ADD_USER_BTN = USER_CONSTANTS.BUTTON.ADD_USER_TEXT;
  TITLE_PAGE = USER_CONSTANTS.PAGE_TITLE;
  OPERATIONS = [LIST_DATA_EVENTS.VIEW_DATA];
  CLICK_ACTION = LIST_DATA_EVENTS.EDIT_DATA;
  SAVE = USER_CONSTANTS.LABEL.SAVE;
  CLOSE = USER_CONSTANTS.LABEL.CLOSE;

  actionCancel = COMPONENT_NAME_MODAL.USER;

  updateDependencies = false;
  addPatient = false;

  async mounted() {
    this.querySearch.userState = [USER_STATES.ACTIVE];
    this.userId = this.$route.params.userId as string;
    this.userDocument = this.$route.params.userDocument as string;
    const views = localStorage.getItem(LOCAL_STORAGE.VIEWS);
    if (
      (JSON.parse(views as string) as string[]).includes(
        LOCAL_STORAGE.ADMIN_ROLE
      )
    ) {
      this.admin = true;
    }
    await this.searchUsers(true);

    this.OPERATIONS = Utils.addExtraOperations(
      this.OPERATIONS,
      COLLECTIONS_NAME.USER
    );
    await this.emitSearchInitializer();

    if (this.checkedQueryParamAdd()) {
      this.editUser(this.userId!, true, USER_CONSTANTS.PAGE_TITLE);
    }
  }

  checkedQueryParamAdd() {
    return this.userDocument || this.userId;
  }

  async emitSearchInitializer() {
    await this.initializeFilters();

    const searchContext: SearchContext = {
      title: USER_CONSTANTS.PAGE_USER_TITLE_SEARCH,
      filterArray: [this.filterArray],
      operations: this.OPERATIONS,
      clickAction: LIST_DATA_EVENTS.EDIT_DATA,
      componentName: COMPONENT_NAME_MODAL.USER,
      callbackHandleOperation: this.handleOperation,
      descriptions: ["userName", "visualStateName"],
      textButtonCreate: USER_CONSTANTS.BUTTON.ADD_USER_TEXT
    };
    const data = searchContext;
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.SET_SEARCH_CONTEXT,
      data
    );
  }

  async initializeFilters() {
    const secondaryFilters = [];
    secondaryFilters.push(USER_CONSTANTS.USER_FILTERS.SECONDARY.NAME);
    secondaryFilters.push(USER_CONSTANTS.USER_FILTERS.SECONDARY.DOCUMENTO);
    const statusFilter = (await this.getUserStatusList()) as SecondaryFilter;
    if (statusFilter !== undefined) {
      secondaryFilters.push(statusFilter);
    }
    secondaryFilters.push(USER_CONSTANTS.USER_FILTERS.SECONDARY.CORREO);
    secondaryFilters.push(USER_CONSTANTS.USER_FILTERS.SECONDARY.TELEFONO);
    const roleResponse = await this.loadRoles();
    if (roleResponse !== undefined) {
      USER_CONSTANTS.USER_FILTERS.SECONDARY.ROLES.options = roleResponse as any;
      secondaryFilters.push(USER_CONSTANTS.USER_FILTERS.SECONDARY.ROLES);
    }
    const dependencyResponse = await this.loadDependecys();
    if (dependencyResponse !== undefined) {
      USER_CONSTANTS.USER_FILTERS.SECONDARY.DEPENDENCIAS.options = dependencyResponse as any;
      secondaryFilters.push(USER_CONSTANTS.USER_FILTERS.SECONDARY.DEPENDENCIAS);
    }
    this.filterArray.secondaryFilters = secondaryFilters;
  }

  async loadRoles() {
    try {
      const responseData = await this.rolesService.getAllActiveRoles();
      if (responseData.code === Http.Found && responseData.data !== undefined) {
        const roleArray: List[] = [];
        const roleList = responseData.data as {
          name: string;
        }[];
        roleList.forEach(item => {
          roleArray.push({ key: item.name, name: item.name });
        });
        return roleArray;
      } else {
        Snackbar.popInfo(LACK_OF_OPTIONS);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${USER_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
      return undefined;
    }
  }

  async loadDependecys() {
    try {
      const responseData = await this.dependenciesService.findAll();
      if (responseData.code === Http.Found && responseData.data !== undefined) {
        const dependencyArray: List[] = [];
        responseData.data.forEach(item => {
          dependencyArray.push({ key: item.data.name, name: item.data.name });
        });
        return dependencyArray;
      } else {
        Snackbar.popInfo(LACK_OF_OPTIONS);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${USER_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
      return undefined;
    }
  }

  async loadPages() {
    this.loadingData = true;
    this.sendDataToLateralMenu(PANEL_INFO_CONSTANTS.ACTION.LOADING_CONTEXT);
    const userDataLoaded = await this.getData(true);
    if (
      userDataLoaded.code === Http.Found &&
      userDataLoaded.data !== undefined
    ) {
      if (userDataLoaded.data.lastReference !== this.docRef) {
        this.itemList = this.itemList.concat(userDataLoaded.data.userArray);
        this.sendDataToLateralMenu(
          PANEL_INFO_CONSTANTS.ACTION.SET_LIST_ITEM_CONTEXT,
          this.itemList
        );

        this.docRef = userDataLoaded.data.lastReference;
        this.loadingData = false;
        return;
      } else {
        this.canSearch = false;
      }
    } else {
      if (userDataLoaded.code !== Http.NotFound) {
        Snackbar.popError(userDataLoaded.message);
      }
      this.canSearch = false;
    }
    this.loadingData = false;
    this.sendDataToLateralMenu(PANEL_INFO_CONSTANTS.ACTION.LOADED_CONTEXT);
  }

  async showUserDetails(id: string) {
    try {
      const response = await this.userService.getUserVersionById(id);

      /* istanbul ignore else */
      if (response.code === Http.Found && response.data != null) {
        this.userModel = response.data.userData;
        this.setReadonlySchema();
        this.dateCreated = this.userModel.dateCreated
          ? new Date(this.userModel.dateCreated).toLocaleString("es-CO")
          : "";

        this.dateModified = this.userModel.dateChanged
          ? new Date(this.userModel.dateChanged).toLocaleString("es-CO")
          : "";
        this.outdatedMessage = response.data
          ? (response.data.versionValidation as string)
          : "";
        this.dialogPreview = true;
        this.clearModel = true;
      } else {
        Snackbar.popInfo(response.message);
      }
    } catch (error) {
      if ((error as Error).message === GENERAL_CONSTANTS.FORBIDDEN) {
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + USER_ACCESS.GET);
      } else {
        Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
      }
    }
  }

  editUser(userId: string, addPatient?: boolean, title?: string) {
    this.addPatient = addPatient ? true : false;
    this.userId = userId;
    this.showUser(userId, USER_CONSTANTS.EDIT_USER, title);
    this.key++;
  }

  onButtonAdd() {
    this.showUser("", USER_CONSTANTS.CREATE_USER);
    this.userDocument = "";
    this.addPatient = false;
  }

  showUser(id: string, accion: string, title?: string) {
    if (accion === USER_CONSTANTS.CREATE_USER) {
      if (this.isVisibleSaveUser) {
        this.actionCancel = COMPONENT_NAME_MODAL.USER;
        this.callCancelModal();
      } else {
        this.userId = "";
        this.isVisibleSaveUser = true;
        this.currentIcon = GENERAL_CONSTANTS.ICONS.CANCEL;
        this.tooltip = FORM_MESSAGES.CANCEL_MODAL.TITLE;
        this.TITLE_PAGE = USER_CONSTANTS.ADD_PAGE_TITLE;
        this.sendDataToLateralMenu(
          PANEL_INFO_CONSTANTS.ACTION.SET_SELECTED_ITEM_NULL,
          { showOptions: this.isVisibleSaveUser }
        );
      }

      return;
    }

    if (accion === USER_CONSTANTS.EDIT_USER) {
      const user = this.itemList.find(
        (item: UserStatus) => item.id === this.userId
      );
      if (user && user.userState != USER_STATES.ACTIVE) {
        return;
      }
      this.currentIcon = GENERAL_CONSTANTS.ICONS.CANCEL;
      this.tooltip = FORM_MESSAGES.CANCEL_MODAL.TITLE;
      this.userId = id;
      this.sendDataToLateralMenu(
        PANEL_INFO_CONSTANTS.ACTION.SET_SELECTED_ITEM,
        id
      );
      this.TITLE_PAGE = user?.userName
        ? user.userName
        : title
        ? title
        : USER_CONSTANTS.PAGE_EDIT_TITLE;
      this.isVisibleSaveUser = true;
      return;
    }

    this.userId = id;
    this.key++;
  }

  async deleteUser(id: string) {
    try {
      const responseData = await this.userService.deleteUser(id);
      if (responseData.code === Http.Ok) {
        Snackbar.popSuccess(responseData.message);
        this.searchUsers(true);
      } else if (responseData.code === Http.Found) {
        Snackbar.popWarning(
          USER_CONSTANTS.DIALOG_MESSAGE.USER_COULD_NOT_BE_DELETED
        );
      } else {
        Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
      }
    } catch (error) {
      if ((error as Error).message === GENERAL_CONSTANTS.FORBIDDEN) {
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + USER_ACCESS.DELETE);
      } else {
        Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
      }
    }
  }

  closeModalPreview() {
    this.dialogPreview = false;
    this.clearModel = false;
  }

  async onBottom() {
    if (this.canSearch && !this.loadingData) {
      await this.loadPages();
      return;
    }

    this.sendDataToLateralMenu(PANEL_INFO_CONSTANTS.ACTION.LOADED_CONTEXT);
  }

  async handleOperation(action: string, itemId: string) {
    switch (action) {
      case LIST_DATA_EVENTS.VIEW_DATA:
        await this.showUserDetails(itemId);
        break;
      case LIST_DATA_EVENTS.EDIT_DATA:
        this.editUser(itemId);
        break;
      case LIST_DATA_EVENTS.DELETE_DATA:
        this.deleteUser(itemId);
        this.closeSaveUser();
        break;
      case LIST_DATA_EVENTS.ACTIVE_DATA:
        this.updateStateUser(itemId, STATE.ACTIVE);
        this.closeSaveUser();
        break;
      case LIST_DATA_EVENTS.DESACTIVED_DATA:
        this.updateStateUser(itemId, STATE.INACTIVE);
        this.closeSaveUser();
        break;
      case LIST_DATA_EVENTS.CANCEL_DATA:
        switch (this.actionCancel) {
          case COMPONENT_NAME_MODAL.USER:
            this.closeSaveUser();

            break;
          case COMPONENT_NAME_MODAL.USER_TEMPLATE:
            this.showModalUserTemplate = false;
            break;
          case COMPONENT_NAME_MODAL.ROLE:
            this.showModalRole = false;
            break;
        }
        break;
    }
  }

  closeSaveUser() {
    this.isVisibleSaveUser = false;
    this.currentIcon = GENERAL_CONSTANTS.ICONS.ADD;
    this.tooltip = USER_CONSTANTS.BUTTON.ADD_USER_TEXT;
    this.TITLE_PAGE = USER_CONSTANTS.PAGE_TITLE;
    this.userId = "";
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.SET_SELECTED_ITEM_NULL,
      { showOptions: this.isVisibleSaveUser }
    );
    this.clearRoute();
  }

  clearRoute() {
    NavigationService.replaceTo(SystemView.USER);
  }

  async updateStateUser(id: string, state: string) {
    try {
      const responseData = await this.userService.updateStateUserById(
        id,
        state
      );
      if (responseData.code === Http.Ok) {
        Snackbar.popSuccess(USER_CONSTANTS.DIALOG_MESSAGE.UPDATE);
        await this.searchUsers(true);
      } else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    } catch (error) {
      if ((error as Error).message === GENERAL_CONSTANTS.FORBIDDEN) {
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + USER_ACCESS.PUT);
      } else {
        Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
      }
    }
  }

  // eslint-disable-next-line  @typescript-eslint/no-non-null-assertion
  sendDataToLateralMenu(action: string, data?: any) {
    store.commit(STORE_CONSTANTS.TO_LATERAL_MENU, {
      from: PANEL_INFO_CONSTANTS.FROM.CRUD,
      type: PANEL_INFO_CONSTANTS.TYPE.SEARCH,
      action: action,
      data: data
    });
  }

  async beforeRouteLeave(to: Route, from: Route, next: NavigationGuardNext) {
    await this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.DISABLE_SEARCH_CONTEXT
    );
    next();
  }

  @Watch("dataToMainView")
  handleDataToMainView() {
    const validations: Record<string, void> = {
      Panel: this.panelValidation()
    };

    validations[this.dataToMainView.from];
  }

  onUserIdEdit(userId: string) {
    this.$nextTick(function() {
      this.TITLE_PAGE = userId;
      this.editUser(userId);
    });
  }

  panelValidation() {
    /* istanbul ignore else */

    if (this.dataToMainView.type === PANEL_INFO_CONSTANTS.TYPE.SEARCH) {
      switch (this.dataToMainView.action) {
        case PANEL_INFO_CONSTANTS.ACTION.DO_SEARCH_TEMPLATE:
          this.querySearch = this.dataToMainView.data;
          this.searchUsers(true);
          break;
        case PANEL_INFO_CONSTANTS.ACTION.DO_ON_BOTTOM_CONTEXT:
          this.onBottom();
          break;
        case PANEL_INFO_CONSTANTS.ACTION.SHOW_CRUD_SAVE:
          if (this.querySearch.name !== undefined) {
            this.userNameSearch = this.querySearch.name[0];
          }
          this.onButtonAdd();
          break;
      }
    } else if (this.dataToMainView.type === PANEL_INFO_CONSTANTS.TYPE.OPTIONS) {
      if (
        this.dataToMainView.action ===
        PANEL_INFO_CONSTANTS.ACTION.SHOW_ADD_USER_TEMPLATE
      ) {
        this.showModalUserTemplate = true;
      }
      if (
        this.dataToMainView.action === PANEL_INFO_CONSTANTS.ACTION.SHOW_ADD_ROLE
      ) {
        this.showModalRole = true;
      }
      if (
        this.dataToMainView.action ===
        PANEL_INFO_CONSTANTS.ACTION.SHOW_ADD_DEPENDENCIES
      ) {
        this.showModalDependencies = true;
      }
    }
  }

  async searchUsers(shouldSearch: boolean) {
    if (!shouldSearch) return;
    this.loadingData = true;
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.LOADING_CONTEXT_AND_HIDE_CARDS
    );

    this.itemList = [];
    this.canSearch = false;
    this.userList = await this.getData(false);
    if (this.userList.code === Http.Found && this.userList.data !== undefined) {
      this.itemList = this.userList.data.userArray;
      this.sendDataToLateralMenu(
        PANEL_INFO_CONSTANTS.ACTION.SET_LIST_ITEM_CONTEXT,
        this.itemList
      );

      this.docRef = this.userList.data.lastReference;
      this.canSearch = true;
    } else {
      this.sendDataToLateralMenu(PANEL_INFO_CONSTANTS.ACTION.LOADED_CONTEXT);
      if (this.userList.code === Http.NotFound) {
        Snackbar.popInfo(this.userList.message);
      } else {
        Snackbar.popError(this.userList.message);
      }
    }

    this.loadingData = false;
  }

  async getData(loadPages?: boolean): Promise<Response<UserPagination>> {
    try {
      const filterQuery: UserQuery = {};

      if (typeof this.querySearch !== KEYTYPE_CONSTANTS.UNDEFINED) {
        if (this.querySearch?.userState)
          filterQuery.userState = this.querySearch.userState;
        if (this.querySearch?.userEmail)
          filterQuery.userEmail = this.querySearch.userEmail;
        if (this.querySearch?.userPhone)
          filterQuery.userPhone = this.querySearch.userPhone;
        if (this.querySearch?.userDocument)
          filterQuery.userDocument = this.querySearch.userDocument;
        if (this.querySearch?.name) filterQuery.name = this.querySearch.name;
        if (this.querySearch?.userRole)
          filterQuery.userRole = this.querySearch.userRole;
        if (this.querySearch.dependency)
          filterQuery.dependency = this.querySearch.dependency;
      }

      if (loadPages) {
        filterQuery.idReference = this.docRef;
      }

      if (filterQuery.name) {
        filterQuery.notPaginate = true;
      }

      const data = await this.userService.getUsersByFiltersArrayUsersCrud(
        filterQuery
      );

      data.data?.userArray.map(x => {
        x.state = x.userState;
        return x;
      });

      return data;
    } catch (error) {
      let responseError: Response<UserPagination>;
      if ((error as Error).message === GENERAL_CONSTANTS.FORBIDDEN) {
        responseError = {
          code: Http.Forbidden,
          message: FORM_MESSAGES.FORBIDDEN_REQUEST + USER_ACCESS.GET,
          data: { userArray: [], lastReference: "" }
        };
      } else {
        responseError = {
          code: Http.BadRequest,
          message: FORM_MESSAGES.REQUEST_FAILED,
          data: { userArray: [], lastReference: "" }
        };
      }
      return responseError;
    }
  }

  callCancelModal() {
    const modalUserTemplate: SearchContextModal = {
      componentName: this.actionCancel
    };
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.MODAL_CANCEL,
      modalUserTemplate
    );
  }

  closeModalSaveUserTemplate() {
    this.actionCancel = COMPONENT_NAME_MODAL.USER_TEMPLATE;
    this.callCancelModal();
  }

  closeModalSaveRole() {
    this.actionCancel = COMPONENT_NAME_MODAL.ROLE;
    this.callCancelModal();
  }

  handleModalSaveDependencies(action: string) {
    this.showModalDependencies = false;
    this.updateDependencies = action === this.SAVE;
  }

  async cleanSaveUserComponent() {
    this.isVisibleSaveUser = false;
    this.currentIcon = GENERAL_CONSTANTS.ICONS.ADD;
    this.tooltip = USER_CONSTANTS.BUTTON.ADD_USER_TEXT;
    this.TITLE_PAGE = USER_CONSTANTS.PAGE_TITLE;

    await this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.SET_SELECTED_ITEM_NULL,
      { showOptions: this.isVisibleSaveUser }
    );
    this.userDocument = "";
    this.addPatient = false;

    await this.searchUsers(true);
    this.clearRoute();
  }

  setReadonlySchema() {
    this.userModel.schema?.schema.allOf.forEach(field => {
      Object.keys(field.properties).forEach(key => {
        if (
          field.properties[key]["x-display"] ==
          FORM_TEMP_CONSTANTS.FIELD_TYPE.SLIDER
        )
          field.properties[key].readOnly = true;
        field.properties[key]["x-options"] = {
          disableAll: true
        };
      });
    });
    this.userModel.schema?.phoneComponentList.forEach(phone => {
      phone.enabled = false;
    });
  }

  async getUserStatusList() {
    try {
      const userStatusResponse = await this.listService.getListOptionsByName(
        LIST_CONSTANTS.USERS_STATES_LIST_NAME.toUpperCase()
      );
      if (
        userStatusResponse.code === Http.Found &&
        userStatusResponse.data !== undefined
      ) {
        const statusFilter = lodash.cloneDeep(
          USER_CONSTANTS.USER_FILTERS.SECONDARY.STATUS
        );
        statusFilter.options = userStatusResponse.data.map(userState => ({
          name: userState.title,
          key: userState.id
        })) as Array<{ name: string; key: string }>;

        return statusFilter;
      }

      Snackbar.popInfo(userStatusResponse.message);
      return {};
    } catch (error) {
      if ((error as Error).message === GENERAL_CONSTANTS.FORBIDDEN) {
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + USER_ACCESS.PUT);
      } else {
        Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
      }
      return {};
    }
  }
}
